import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Home.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, EffectCreative, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/swiper-bundle.css';
import AppImages from '../../Utils/ThemeImages';

import ReUsable from '../Re-usable/ReUsable';
import TestimonialSlider from '../Re-usable/TestimonialSlider';
import OurTeam from '../Re-usable/OurTeam';
import { useNavigate } from 'react-router-dom';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import '@splidejs/splide/dist/css/splide.min.css';
import { Helmet } from 'react-helmet';

const Home = () => {

  const navigate = useNavigate()


  const canonicalUrl = "https://whitetowerinternational.com/Home";

  const slidesContent = [
    {
      title: 'STEVEDORING & PORT HANDLING',
      image: AppImages.homebannerSlide01
    },
    {
      title: 'Connecting People, Moving the World Forward',
      image: AppImages.craneSteel
    },
    {
      title: 'SHIPMENT & CARGO HANDLING',
      image: AppImages.homebannerSlide02
    },
  ];


  const yearsBlock = [
    {
      title: '10+',
      content: 'Years of Stevedoring Experience',
      active: false,
    },
    {
      title: '8+',
      content: 'Years of Container Handling',
      active: true,
    },
    {
      title: '12+',
      content: 'Years of Experienced Employees',
      active: false,
    },
    {
      title: '60+',
      content: 'Experienced Crane Operators',
      active: false,
    }
  ];


  const ourPartners = [
    {
      image: AppImages.jindalLogo,
    },
    {
      image: AppImages.duqmLogo,
    },
    {
      image: AppImages.soharLogo,
    },
    {
      image: AppImages.steinwegLogo,
    },
    {
      image: AppImages.soharSteelLogo,
    },
    {
      image: AppImages.jindalLogo,
    },
    {
      image: AppImages.duqmLogo,
    },
    {
      image: AppImages.soharLogo,
    },
    {
      image: AppImages.steinwegLogo,
    },
    {
      image: AppImages.soharSteelLogo,
    },
  ]

  const portDuqm = [
    {
      title: 'Steel Pipes',
      content: 'Steel pipes play a crucial role in the cargo and shipment industry due to their durability, strength, and versatility.',
      image: AppImages.steelPipes,
    },
    {
      title: 'Steel Plates',
      content: 'Steel plates are an essential component in various industries, from construction and shipbuilding ',
      image: AppImages.steelPlates,
    },
    {
      title: 'Project Cargo',
      content: 'Project cargo refers to the transportation of large, heavy, complex, or high-value equipment and materials',
      image: AppImages.projectCargo,
    },
    {
      title: 'Containers',
      content: 'A container vessel is a type of cargo ship specifically designed to carry cargo in standardized containers',
      image: AppImages.containerVessel,
    },
    {
      title: 'Dolomite',
      content: 'Dolomite is a sedimentary rock primarily composed of calcium magnesium carbonate. It is similar to limestone',
      image: AppImages.dolomite,
    },
    {
      title: 'Limestone',
      content: 'Limestone is a sedimentary rock primarily composed of calcium .It forms from the accumulation of organic materials',
      image: AppImages.limeStone,
    },
    {
      title: 'Copperslag',
      content: 'Copper slag is a by-product generated from the copper smelting and refining process. ',
      image: AppImages.copperSlag,
    },
    {
      title: 'Steel Coils',
      content: 'Steel coils are flat-rolled products of steel that are wound into coils or rolls.',
      image: AppImages.steelCoils,
    },
    {
      title: 'Steel Rebar',
      content: 'Steel coils are flat-rolled products of steel that are wound into coils or rolls.',
      image: AppImages.steelRebar,
    },
    {
      title: 'Steel Square Billets',
      content: 'Steel coils are flat-rolled products of steel that are wound into coils or rolls.',
      image: AppImages.squareBillet,
    },
    {
      title: 'Steel Round Blooms',
      content: 'Steel coils are flat-rolled products of steel that are wound into coils or rolls.',
      image: AppImages.roundBloom,
    },
    {
      title: 'Steel Wires',
      content: 'Steel coils are flat-rolled products of steel that are wound into coils or rolls.',
      image: AppImages.steelWires,
    },
    {
      title: 'Fishing Boat',
      content: 'A fishing boat is a vessel specifically designed for catching fish in various bodies of water, including oceans',
      image: AppImages.fishingBoat,
    },
    {
      title: 'Explosive Material',
      content: 'Explosive materials are substances that, when subjected to certain conditions such as heat, shock',
      image: AppImages.explosiveMaterial,
    },
  ]

  const portJindaal = [
    {
      title: 'Rounds Blooms',
      content: 'These are semi-finished steel products that serve as precursors for manufacturing wide range of steel components',
      image: AppImages.roundBloom,
    },
    {
      title: 'Steel Rebar',
      content: 'Steel rebar s a steel rod used as a tension device in reinforced concrete and masonry structures to strengthen',
      image: AppImages.steelRebar,
    },
    {
      title: 'Square Billet',
      content: 'It is a semi-finished metal product with a square cross-section that is produced through casting or hot rolling.',
      image: AppImages.squareBillet,
    },
    {
      title: 'Steel Wires',
      content: 'Steel wires are thin, flexible strands of steel used in various industrial, construction.',
      image: AppImages.steelWires,
    },
    {
      title: 'Project Cargo',
      content: 'Project cargo refers to the transportation of large, heavy, complex, or high-value equipment and materials',
      image: AppImages.projectCargo,
    },
    {
      title: 'Limestone Bags',
      content: 'Limestone bags are essential for the storage, transportation, and distribution of limestone in both powder and granular forms. ',
      image: AppImages.limeStoneBags,
    },
    {
      title: 'Scraps',
      content: 'Scrap cargo shipment services facilitate the movement of these materials from  centers to recycling facilities plants.',
      image: AppImages.scraps,
    },
    {
      title: 'Bulk Cargo',
      content: 'Bulk cargo refers to large quantities of unpackaged goods that are transported in large quantities',
      image: AppImages.bulkCargo,
    },
    {
      title: 'Dolomite Bags',
      content: 'Dolomite is often transported and distributed in bulk via dolomite bags. These bags are designed to ensure safe',
      image: AppImages.dolomiteBags,
    },
  ]



  return (
    <div className="Home">
        <Helmet>
          <link rel="canonical" href={canonicalUrl} />
          <title>WhiteTower - Home</title>
        </Helmet>
        <div className="home-inner-section">
          <section className="home-section-1">
            <div className="home-section-1-inner">
              <div className="home-slider-section relative">
                <Swiper
                  grabCursor={true}
                  loop={true}
                  pagination={{
                    el: '.custom-pagination',
                    clickable: true,
                  }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  effect={'creative'}
                  creativeEffect={{
                    prev: {
                      shadow: true,
                      translate: ['-120%', 0, -500],
                    },
                    next: {
                      shadow: true,
                      translate: ['120%', 0, -500],
                    },
                  }}
                  modules={[EffectCreative , Pagination , Autoplay]}
                  className="mySwiper2"
                >
                  {slidesContent.map((items , index) => {
                    return (
                      <SwiperSlide key={index}>
                        <div className="home-similar-slides home-banner-slide-01">
                            <div className="slide-image-sec-home">
                              <img src={items.image} className='h-full object-cover' alt="" />
                            </div>
                            <div className="slide-content-section-home">
                              <h1 className='text-center'>{items.title}</h1>
                            </div>
                        </div>
                      </SwiperSlide>
                    )
                  })}
                  <div className="custom-pagination z-10 absolute bottom-10 right-20"></div>
                </Swiper>
              </div>
            </div>
          </section>
          <section className="home-section-2">
            <div className="home-inner-section-2">
              <div className="container">
                  <div className="section-2-head-part">
                    <div className="grid grid-cols-2 items-center">
                      <div className="left-main-head-sec-2">
                        <h2 className='wow animate__animated animate__fadeInUp'>Background and Experience </h2>
                      </div>
                      <div className="right-title-head-sec-2">
                          <p className='wow animate__animated animate__fadeInUp'><span>WHITE TOWER INTERNATIONAL LLC </span> delivers reliable and professional port handling solutions, ensuring smooth and timely operations at key maritime hubs.</p>
                      </div>
                    </div>
                  </div>
                  <div className="section-2-content-part">
                    <div className="grid grid-cols-2 gap-5">
                      <div className="years-blks-sec-2 grid grid-cols-2 gap-5 wow animate__animated animate__fadeInLeft">
                          {yearsBlock.map((items , index) => {
                            return (
                              <div className={`single-home-sec-2-yearblk flex flex-col gap-[14px] ${items.active === true ? 'active' : ''}`} key={index}>
                                <h2>{items.title}</h2>
                                <p>{items.content}</p>
                              </div>
                            )
                          })}
                      </div>
                      <div className="about-us-blk-sec-2 grid grid-cols-2 wow animate__animated animate__fadeInRight">
                        <div className="left-about-us-content-sec-2 flex flex-col justify-between">
                          <p>White Tower International LLC is the best choice for port handling and stevedoring in Oman. We specialize in a wide range of cargo, from project cargo and heavy lifts to container vessels and steel products. Our experienced team is committed to providing reliable and efficient handling services, making us a trusted partner for your logistics needs.</p>
                          <button type='button' onClick={() => navigate('/About-Us')} className='text-left'><i className="bi bi-arrow-up-right text-white"></i></button>
                        </div>
                        <div className="right-about-us-image-sec-2">
                          <img src={AppImages.containersNew} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </section>
          <section className="home-section-3">
            <div className="inner-home-section-3">
              <div className="container">
                <div className="home-section-3-heading">
                  <h2 className='wow animate__animated animate__fadeInLeft'>Cargo handling by WhiteTower International</h2>
                </div>
                <div className="grid grid-cols-4 gap-5">
                    {portDuqm.map((items , index) => {
                      return (
                        <div className="single-services-blk-section wow animate__animated animate__fadeInUp" key={index}>
                          <div className="top-image-section-ser-blk">
                            <img className='object-cover' src={items.image} alt="" />
                          </div>
                          <div className="bottom-content-serv flex flex-col gap-2">
                              <h4>{items.title}</h4>
                              {/* <p>{items.content}</p> */}
                          </div>
                        </div>
                      )
                    })}
                    <div className="col-span-2 hidden port-image-section-sec-3 h-full wow animate__animated animate__fadeInUp">
                      <div className="port-image-home-sec-3 h-full">
                        <img src={AppImages.portDuqm} className='h-full object-cover' alt="" />
                        <div className="port-image-overlay-sec-sec-3">
                          <h4>Port of  DUQM</h4>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </section>
          <section className="home-section-4">
            <div className="inner-home-section-4">
              <div className="container">
                <div className="home-section-4-heading">
                  <h2 className='wow animate__animated animate__fadeInLeft'>OUR PARTNERS</h2>
                </div>
              </div>
              <Splide
                extensions={{ AutoScroll }}
                options={{
                  type: 'loop',
                  perPage: 3,
                  perMove: 1,
                  speed: 1000,
                  pagination: false,
                  navigation: false,
                  arrows: false,
                  gap: 50
                }}
              >
                {ourPartners.map((items , index) => {
                  return (
                    <SplideSlide key={index}>
                      <div className="inner-splide-image-section bg-white shadow-xl px-4 py-6 text-center overflow-hidden group">
                        <img src={items.image} className='h-full object-contain mx-auto w-full max-h-[100px] group-hover:scale-125 duration-500' alt="" />
                      </div>
                    </SplideSlide>
                  )
                })}
              </Splide>
            </div>
          </section>
          <section className="home-section-4 hidden">
            <div className="inner-home-section-4">
              <div className="container">
                <div className="home-section-4-heading">
                  <h2 className='wow animate__animated animate__fadeInLeft'>Cargo handled in JINDAL SHADEED TERMINAL</h2>
                </div>
                <div className="grid grid-cols-4 gap-5">
                    {portJindaal.map((items , index) => {
                      return (
                        <div className="single-services-blk-section wow animate__animated animate__fadeInUp" key={index}>
                          <div className="top-image-section-ser-blk">
                            <img className='object-cover' src={items.image} alt="" />
                          </div>
                          <div className="bottom-content-serv flex flex-col gap-2">
                              <h4>{items.title}</h4>
                              <p>{items.content}</p>
                          </div>
                        </div>
                      )
                    })}
                    <div className="col-span-3 port-image-section-sec-4 wow animate__animated animate__fadeInUp">
                      <div className="port-image-home-sec-4 h-full">
                        <img src={AppImages.jindalShadeedNew} className='h-full object-cover object-top' alt="" />
                        <div className="port-image-overlay-sec-sec-4">
                          <h4>Port of  JINDAL SHADEED TERMINAL</h4>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </section>
          <section className="home-section-5">
            <div className="inner-home-section-5">
              <div className="container">
                <div className="top-home-sec-5-heading">
                  <h2 className='wow animate__animated animate__fadeInDown'>International Property Network</h2>
                  <p className='wow animate__animated animate__fadeInUp'>Our global reach opens doors to exclusive cargo and shipment opportunities, <br /> providing you with a comprehensive view of the international logistics landscape</p>
                </div>
                <div className="map-image-section text-center">
                  <img src={AppImages.mapImage} className='text-center mx-auto w-full' alt="" />
                </div>
              </div>
            </div>
          </section>
          <section>
            <TestimonialSlider/>
          </section>
          <section className="home-section-7">
            <div className="inner-home-section-7">
              <div className="container">
                <div className="grid-cols-2 grid">
                  <div className="why-chooseus-main-section">
                    <div className="section-7-heading">
                      <h2 className='wow animate__animated animate__fadeInDown'>Why Choose Us?</h2>
                      <div className="para-graph-section-7 flex flex-col gap-7 wow animate__animated animate__fadeInUp">
                        <p>For Over a Decade, White Tower International LLC, is one of the leading company of OMAN, IT has been excelling in the fields of shipping, logistics</p>
                        <p>Stevedoring import & export of cargo through vessel operations with our experienced employees, we carry out erudite cargo handling equipment in SEA ports. </p>
                        <p>We are experienced in handling of all type of cargo -example: (Project cargo & heavy lift, container vessels, break-bulk, dry bulk cargo, and steel cargo like steel Rebar, steel square billets, steel round blooms, steel coils, steel plates.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <OurTeam/>
        </div>
    </div>
  );
}

Home.propTypes = {};

Home.defaultProps = {};

export default Home;
